import { render, staticRenderFns } from "./ktransition.vue?vue&type=template&id=a8b76c8e&scoped=true"
import script from "./ktransition.vue?vue&type=script&lang=js"
export * from "./ktransition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b76c8e",
  null
  
)

export default component.exports